"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var __1 = require("../../..");
var hooks_1 = require("../../../hooks");
var components_1 = require("../components");
var Label_1 = __importDefault(require("../components/Label"));
var Dropdown_1 = __importDefault(require("../inputs/Dropdown"));
var SelectFormaOdposlechu = function (_a) {
    var name = _a.name, label = _a.label, placeholder = _a.placeholder, defaultSelect = _a.defaultSelect, enableReset = _a.enableReset, readOnly = _a.readOnly;
    var _b = formik_1.useField(name), field = _b[0], helpers = _b[2];
    var _c = hooks_1.useCiselnik('formyOdposlechu'), data = _c.data, loading = _c.loading, error = _c.error;
    react_1.useEffect(function () {
        if (defaultSelect)
            helpers.setValue(defaultSelect.value);
    }, [defaultSelect === null || defaultSelect === void 0 ? void 0 : defaultSelect.value]);
    var loadOptions = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (data) {
                return [2 /*return*/, data.map(function (forma) { return ({ value: forma.id, label: forma.nazev }); })];
            }
            return [2 /*return*/, []];
        });
    }); };
    return (react_1.default.createElement(components_1.Field, { loading: loading, error: error },
        react_1.default.createElement(Label_1.default, { htmlFor: __1.NormalizeString(name) }, label),
        react_1.default.createElement(Dropdown_1.default, { value: field.value, onChange: function (value) { return helpers.setValue(value); }, placeholder: placeholder, loadOptions: loadOptions, enableReset: enableReset, inputId: __1.NormalizeString(name), disabled: readOnly })));
};
SelectFormaOdposlechu.defaultProps = {
    defaultSelect: undefined,
    enableReset: false,
    readOnly: undefined,
};
exports.default = SelectFormaOdposlechu;
